import TenantModelBase from '../_generated/modelBases/tenant-model-base';

export default class TenantModel extends TenantModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
